import React, { useState, useEffect } from "react";
import selectdropdownsvg from "../../../images/selectdropdownsvg.svg";
import whiteselectdown from "../../../images/whiteselectdown.svg";

const DisplayOptions = ({
  isDarkMode,
  mobileDisplayOption,
  setMobileDisplayOption,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Track screen size to determine mobile vs desktop behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle display option change
  const handleDisplayOptionChange = (e) => {
    setMobileDisplayOption(e.target.value);
  };

  return (
    <>
      {/* Desktop Display - Fixed labels for Match Results and Double Chance */}
      {!isMobile && (
        <>
          <span className="text-[#6B7280] dark:text-white text-sm font-normal leading-[128%]">
            1X2
          </span>
          <span className="text-[#6B7280] dark:text-white text-sm font-normal leading-[128%]">
            Double chance
          </span>

          {/* Desktop dropdown - Only for GG/NG vs Over/Under toggle */}
          <div className="">
            <select
              className="rounded-md bg-[#EFEFEF] dark:bg-darktitleColor py-2 px-[11px] s18:p-[9px_11px] w-[120px] border-none outline-none text-[#6B7280] dark:text-white text-sm font-normal leading-[114%] appearance-none pr-8"
              onChange={handleDisplayOptionChange}
              value={
                mobileDisplayOption === "1x2" ||
                mobileDisplayOption === "double-chance"
                  ? "gg-ng"
                  : mobileDisplayOption
              }
            >
              <option value="gg-ng">GG/NG</option>
              <option value="over-under">Over/Under</option>
            </select>
            <img
              src={isDarkMode ? whiteselectdown : selectdropdownsvg}
              alt="dropdown arrow"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none w-4 h-4"
            />
          </div>
        </>
      )}

      {/* Mobile Display - Dropdown for all 4 markets */}
      {isMobile && (
        <div className="">
          <select
            className="rounded-md bg-[#EFEFEF] dark:bg-darktitleColor py-2 px-[11px] s18:p-[9px_11px] w-[213px] border-none outline-none text-[#6B7280] dark:text-white text-xs font-normal leading-[114%] appearance-none pr-8"
            onChange={handleDisplayOptionChange}
            value={mobileDisplayOption}
          >
            <option value="1x2">1X2</option>
            <option value="double-chance">Double chance</option>
            <option value="gg-ng">GG/NG</option>
            <option value="over-under">Over/Under</option>
          </select>
          <img
            src={isDarkMode ? whiteselectdown : selectdropdownsvg}
            alt="dropdown arrow"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none w-4 h-4"
          />
        </div>
      )}
    </>
  );
};

export default DisplayOptions;
